var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              conteudo: _vm.conteudoModal,
              isVTN: _vm.isVTN,
              isProcesso: _vm.isProcesso,
              isImagem: _vm.isImagem,
              tituloDocumento: _vm.tituloDocumento,
              tipoProcesso: _vm.tipoProcesso,
              isVisualisaProcessoDespacho: _vm.isVisualisaProcessoDespacho
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _vm.showModalVisualizarTermo
        ? _c("app-modal-termo-compromisso", {
            attrs: {
              isTermoAceito: true,
              tipoPagamento: _vm.tipoPagamento,
              dataAceiteTermo: _vm.dataAceiteTermo,
              conteudo: _vm.conteudoModal,
              visualizarTermo: true
            },
            on: { closeModal: _vm.closeModalVisualizarTermo }
          })
        : _vm._e(),
      _vm.showModalVisualizaVTN
        ? _c("AppModalVisualizarVtnRR", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              conteudo: _vm.conteudoModal,
              isVTN: _vm.isVTN
            },
            on: { closeModal: _vm.closeModalVisualizaVTN }
          })
        : _vm._e(),
      _vm.showModalVisualizaVTN
        ? _c("AppModalVisualizarVtnAP", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              conteudo: _vm.conteudoModal,
              isVTN: _vm.isVTN
            },
            on: { closeModal: _vm.closeModalVisualizaVTN }
          })
        : _vm._e(),
      _vm.showModalConversas && _vm.conversas
        ? _c("app-modal-lista-conversas", {
            attrs: { conversas: _vm.conversas },
            on: { closeModal: _vm.closeModalConversas }
          })
        : _vm._e(),
      _vm.showModalSolicitacoesInformacao && _vm.solicitacoesInformacao
        ? _c("app-modal-lista-solicitacoes-informacao", {
            attrs: { solicitacoesInformacao: _vm.solicitacoesInformacao },
            on: { closeModal: _vm.closeModalSolicitacoesInformacao }
          })
        : _vm._e(),
      _vm.showModalProtesto
        ? _c("app-modal-visualizar-protesto", {
            attrs: { protesto: _vm.protesto },
            on: { closeModal: _vm.closeModalProtesto }
          })
        : _vm._e(),
      _vm.data.length > 0
        ? _c(
            "el-collapse",
            _vm._l(_vm.data, function(item, indexItem) {
              return _c(
                "el-collapse-item",
                {
                  key: indexItem,
                  attrs: { title: item.nome },
                  nativeOn: {
                    click: function($event) {
                      return _vm.onCollapse(item, indexItem)
                    }
                  }
                },
                [
                  item.loading
                    ? _c("div", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: item.loading,
                            expression: "item.loading"
                          }
                        ],
                        staticClass: "container-loading"
                      })
                    : _vm._l(item.despachos, function(subItem, indexSubItem) {
                        return _c(
                          "el-card",
                          { key: indexSubItem },
                          [
                            _vm._t("header", [
                              _c("h2", [_vm._v(_vm._s(subItem.titulo))])
                            ]),
                            !_vm.visualizacao && _vm.isInserirAnotacao()
                              ? _c("div", { staticClass: "annotation" }, [
                                  !(
                                    _vm.showAnotacao &&
                                    _vm.indexAnotacao === indexSubItem &&
                                      _vm.indexCollapse === indexItem
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "icon-annotation",
                                          on: {
                                            click: function($event) {
                                              return _vm.handleAnotacoes(
                                                indexSubItem,
                                                indexItem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            { attrs: { content: "Anotação" } },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass:
                                                  "icon-annotation__pointer",
                                                attrs: {
                                                  icon: "comment-alt",
                                                  size: "lg"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "icon-annotation",
                                          attrs: { size: "6x" },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleAnotacoes(
                                                indexSubItem,
                                                indexItem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: "Fechar anotação"
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass:
                                                  "icon-annotation__pointer",
                                                attrs: { icon: "times" }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ])
                              : _vm._e(),
                            subItem.idDespachoTitulo &&
                            subItem.tipo === "ERRATA_TITULO"
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarRetificacaoTitulo(
                                            subItem.idDespachoTitulo
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.errataMinuta))]
                                  )
                                ])
                              : _vm._e(),
                            subItem.idDespachoTitulo &&
                            !["ERRATA_TITULO", "OFICIO_CCR"].includes(
                              subItem.tipo
                            )
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarTitulo(
                                            subItem.idDespachoTitulo
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.tituloMinuta))]
                                  )
                                ])
                              : _vm._e(),
                            subItem.idDespachoTitulo &&
                            subItem.tipo === "OFICIO_CCR"
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarOficio()
                                        }
                                      }
                                    },
                                    [_vm._v("Minuta do ofício")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.tipo === "VTN" &&
                            !_vm.isRoraima && !_vm.isAmapa
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarVTN(
                                            subItem.idVTN
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Resumo da VTN")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.tipo === "VTN" &&
                            !_vm.isRoraima && !_vm.isAmapa &&
                            subItem.formaDePagamento &&
                              subItem.formaDePagamento === "PARCELADO"
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarTermoDeCompromisso(
                                            subItem
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Termo de Compromisso")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.tipo === "VTN" && _vm.isRoraima
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarVTNRR(subItem)
                                        }
                                      }
                                    },
                                    [_vm._v("Resumo da VTN")]
                                  )
                                ])
                              : _vm._e(),
                            _vm.visualizarResumoVtnAp(subItem)
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarVtnAP(subItem)
                                        }
                                      }
                                    },
                                    [_vm._v("Resumo da VTN")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.idDespachoPortaria
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarPortaria(
                                            subItem.idDespachoPortaria
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Portaria")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.idAnaliseAutomatizada
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarLaudo(subItem.id)
                                        }
                                      }
                                    },
                                    [_vm._v("Laudo análise automatizada")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.idLaudo
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarLaudoAutomatico(
                                            subItem.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Laudo análise automatizada")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.idMapa
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarMapaAutomatico(
                                            subItem.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Mapa análise automatizada")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.idDocumentoGabinete
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarReurb(subItem.id)
                                        }
                                      }
                                    },
                                    [_vm._v("Despacho unificado REURB")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._l(subItem.conteudos, function(conteudo) {
                              return _c("div", [
                                conteudo.tipo === "texto" && conteudo.texto
                                  ? _c(
                                      "div",
                                      { staticClass: "container-item" },
                                      [
                                        _c("p", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              conteudo.label.endsWith("?")
                                                ? conteudo.label
                                                : conteudo.label + ":"
                                            ) + "  "
                                          )
                                        ]),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(conteudo.texto)
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                conteudo.tipo === "checkbox"
                                  ? _c(
                                      "div",
                                      { staticClass: "container-item" },
                                      [
                                        _c("p", { staticClass: "label" }, [
                                          _vm._v(_vm._s(conteudo.label))
                                        ]),
                                        _c(
                                          "el-table",
                                          {
                                            attrs: {
                                              data: conteudo.anexos,
                                              "show-header": false
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { prop: "tipo" }
                                            }),
                                            _c("el-table-column", {
                                              attrs: { prop: "label" }
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "isValido",
                                                align: "right",
                                                width: "180"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "action-column"
                                                          },
                                                          [
                                                            _vm.visualizarDocumentosPDF
                                                              ? _c(
                                                                  "el-tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "btn-actions",
                                                                    attrs: {
                                                                      effect:
                                                                        "dark",
                                                                      content: _vm.verificarTooltip(
                                                                        scope.row
                                                                      ),
                                                                      placement:
                                                                        "left"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      [
                                                                        !scope
                                                                          .row
                                                                          .isDocumentoAutenticavel
                                                                          ? _c(
                                                                              "el-button",
                                                                              {
                                                                                staticClass:
                                                                                  "button",
                                                                                attrs: {
                                                                                  disabled: _vm.verificarExtensao(
                                                                                    scope.row
                                                                                  )
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.abrirDocumento(
                                                                                      scope.row
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "font-awesome-icon",
                                                                                  {
                                                                                    attrs: {
                                                                                      icon:
                                                                                        "eye",
                                                                                      size:
                                                                                        "lg"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                staticClass:
                                                                  "btn-actions",
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    "Baixar Documento",
                                                                  placement:
                                                                    "left"
                                                                }
                                                              },
                                                              [
                                                                !scope.row
                                                                  .isDocumentoAutenticavel
                                                                  ? _c(
                                                                      "el-button",
                                                                      {
                                                                        staticClass:
                                                                          "button",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.emitDownload(
                                                                              {
                                                                                id:
                                                                                  scope
                                                                                    .row
                                                                                    .id,
                                                                                nome:
                                                                                  scope
                                                                                    .row
                                                                                    .label,
                                                                                isDocumentoAutenticavel:
                                                                                  scope
                                                                                    .row
                                                                                    .isDocumentoAutenticavel,
                                                                                caminho:
                                                                                  scope
                                                                                    .row
                                                                                    .caminho
                                                                              }
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "font-awesome-icon",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "download",
                                                                              size:
                                                                                "lg"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                staticClass:
                                                                  "btn-actions",
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    "Visualizar Documento",
                                                                  placement:
                                                                    "left"
                                                                }
                                                              },
                                                              [
                                                                scope.row
                                                                  .isDocumentoAutenticavel
                                                                  ? _c(
                                                                      "el-button",
                                                                      {
                                                                        staticClass:
                                                                          "button",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.abrirPdf(
                                                                              scope.row
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "font-awesome-icon",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "eye",
                                                                              size:
                                                                                "lg"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            scope.row.isValido
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "valido"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "check",
                                                                          size:
                                                                            "lg"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "  Válido"
                                                                      )
                                                                    ])
                                                                  ],
                                                                  1
                                                                )
                                                              : scope.row
                                                                  .isValido ===
                                                                false
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "invalido"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "times",
                                                                          size:
                                                                            "lg"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "  Inválido"
                                                                      )
                                                                    ])
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                conteudo.tipo === "anexos"
                                  ? _c(
                                      "div",
                                      { staticClass: "container-item" },
                                      [
                                        _c("p", { staticClass: "label" }, [
                                          _vm._v(_vm._s(conteudo.label))
                                        ]),
                                        _c(
                                          "el-table",
                                          {
                                            attrs: {
                                              data: conteudo.anexos,
                                              "show-header": false
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { prop: "tipo" }
                                            }),
                                            _c("el-table-column", {
                                              attrs: { prop: "label" }
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "right",
                                                width: "110"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        scope.row
                                                          .isDocumentoAutenticavel ||
                                                        _vm.isEstadoMA ||
                                                        _vm.isAmapa ||
                                                        _vm.isEstadoBA
                                                          ? _c(
                                                              "app-action-button",
                                                              {
                                                                attrs: {
                                                                  disabled: _vm.isVisualizarDocumentos(
                                                                    scope.row
                                                                  ),
                                                                  cor: _vm.isVisualizarDocumentos(
                                                                    scope.row
                                                                  )
                                                                    ? "#C0C4CC"
                                                                    : "#666666",
                                                                  text: _vm.isVisualizarDocumentos(
                                                                    scope.row
                                                                  )
                                                                    ? "Não é possível exibir esse arquivo"
                                                                    : "Visualizar",
                                                                  icone: "eye",
                                                                  fontSize: "18"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.abrirPdf(
                                                                      scope.row
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        !scope.row
                                                          .isDocumentoAutenticavel
                                                          ? _c(
                                                              "app-action-button",
                                                              {
                                                                attrs: {
                                                                  text:
                                                                    "Baixar arquivo",
                                                                  icone:
                                                                    "download",
                                                                  fontSize: "18"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.emitDownload(
                                                                      {
                                                                        id:
                                                                          scope
                                                                            .row
                                                                            .id,
                                                                        nome:
                                                                          scope
                                                                            .row
                                                                            .label,
                                                                        isDocumentoAutenticavel:
                                                                          scope
                                                                            .row
                                                                            .isDocumentoAutenticavel,
                                                                        caminho:
                                                                          scope
                                                                            .row
                                                                            .caminho
                                                                      }
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                conteudo.tipo === "dae"
                                  ? _c(
                                      "div",
                                      { staticClass: "container-item" },
                                      [
                                        _c("p", { staticClass: "label" }, [
                                          _vm._v(_vm._s(conteudo.label))
                                        ]),
                                        _c(
                                          "el-table",
                                          {
                                            attrs: {
                                              data: conteudo.anexos,
                                              "show-header": false
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { prop: "label" }
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "right",
                                                prop: "tipo"
                                              }
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "right",
                                                width: "110"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        scope.row.isDae
                                                          ? _c(
                                                              "el-tooltip",
                                                              {
                                                                staticClass:
                                                                  "item",
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    "Baixar DAE",
                                                                  placement:
                                                                    "left"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    staticClass:
                                                                      "button",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.emitDownload(
                                                                          {
                                                                            id:
                                                                              scope
                                                                                .row
                                                                                .id,
                                                                            nome:
                                                                              scope
                                                                                .row
                                                                                .id +
                                                                              ".pdf",
                                                                            isDae:
                                                                              scope
                                                                                .row
                                                                                .isDae
                                                                          }
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "download",
                                                                          size:
                                                                            "lg"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                conteudo.tipo === "publicacao"
                                  ? _c(
                                      "div",
                                      { staticClass: "container-item" },
                                      [
                                        _c("p", { staticClass: "label" }, [
                                          _vm._v(_vm._s(conteudo.label))
                                        ]),
                                        _c(
                                          "el-table",
                                          {
                                            attrs: {
                                              data: conteudo.anexos,
                                              "show-header": false
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { prop: "label" }
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                align: "right",
                                                width: "110"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            staticClass: "item",
                                                            attrs: {
                                                              effect: "dark",
                                                              content:
                                                                "Baixar arquivo",
                                                              placement: "left"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "el-button",
                                                              {
                                                                staticClass:
                                                                  "button",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.emitDownload(
                                                                      {
                                                                        id:
                                                                          scope
                                                                            .row
                                                                            .id,
                                                                        nome:
                                                                          scope
                                                                            .row
                                                                            .label,
                                                                        isDocumentoAutenticavel:
                                                                          scope
                                                                            .row
                                                                            .isDocumentoAutenticavel
                                                                      }
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "download",
                                                                      size: "lg"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                conteudo.tipo === "portaria"
                                  ? _c(
                                      "div",
                                      { staticClass: "container-item" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "button",
                                            on: {
                                              click: function($event) {
                                                return _vm.openModal()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "button-modal-label"
                                              },
                                              [_vm._v(_vm._s(conteudo.label))]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            }),
                            _vm.mapasExibidos.includes(indexItem) &&
                            subItem.localizacoes &&
                            subItem.localizacoes.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "container-item" },
                                  [
                                    _c("app-resumo-mapa", {
                                      attrs: {
                                        idMapa:
                                          "id-mapa-localizacao-" + subItem.id,
                                        height: 30,
                                        localizacoes: subItem.localizacoes.map(
                                          function(item) {
                                            return item.geometry
                                          }
                                        ),
                                        isVisualizarCadastro: true
                                      }
                                    }),
                                    _c("div", { staticClass: "flex-button" }, [
                                      _c(
                                        "div",
                                        { staticClass: "btn" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadShape(
                                                    subItem.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fal fa-download"
                                              }),
                                              _vm._v("  Download do shapefile")
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            subItem.hasConversas
                              ? _c(
                                  "div",
                                  { staticClass: "container-item" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "button",
                                        on: {
                                          click: function($event) {
                                            return _vm.openModalConversas(
                                              subItem
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-row",
                                          { staticClass: "button-modal-label" },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-comments-alt"
                                            }),
                                            _vm._v("  Ver mensagens")
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            subItem.hasSolicitacoesInformacao
                              ? _c(
                                  "div",
                                  { staticClass: "container-item" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "button",
                                        on: {
                                          click: function($event) {
                                            return _vm.openModalSolicitacoesInformacao(
                                              subItem
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-row",
                                          { staticClass: "button-modal-label" },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-comments-alt"
                                            }),
                                            _vm._v(
                                              "  Ver informações solicitadas"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            subItem.hasProtesto
                              ? _c(
                                  "div",
                                  { staticClass: "container-item" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "button",
                                        on: {
                                          click: function($event) {
                                            return _vm.openModalProtesto(
                                              subItem
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-row",
                                          { staticClass: "button-modal-label" },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-comments-alt"
                                            }),
                                            _vm._v(
                                              "  Protesto ativo no processo"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            item.despachos[0].titulo === "Emissão de Custas" &&
                            _vm.isAmapa
                              ? _c(
                                  "div",
                                  { staticClass: "container-item" },
                                  [
                                    item.despachos[indexSubItem].emissaoCusta !=
                                    null
                                      ? _c("visualizar-emissao-custas", {
                                          attrs: {
                                            emissaoCusta:
                                              item.despachos[indexSubItem]
                                                .emissaoCusta
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showAnotacao &&
                            _vm.indexAnotacao === indexSubItem &&
                              _vm.indexCollapse === indexItem
                              ? _c(
                                  "div",
                                  { staticClass: "container-item" },
                                  [
                                    _c("p", { staticClass: "label" }, [
                                      _vm._v("Anotações:")
                                    ]),
                                    _c("el-input", {
                                      attrs: { type: "textarea" },
                                      on: {
                                        blur: function($event) {
                                          return _vm.getAnotacao(
                                            $event,
                                            indexItem,
                                            indexSubItem
                                          )
                                        }
                                      },
                                      model: {
                                        value: subItem.anotacao,
                                        callback: function($$v) {
                                          _vm.$set(subItem, "anotacao", $$v)
                                        },
                                        expression: "subItem.anotacao"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.isInserirVisualizarAnotacao() &&
                            subItem.anotacao
                              ? _c("div", { staticClass: "container-item" })
                              : _vm._e(),
                            subItem.validacao
                              ? _c(
                                  "div",
                                  { staticClass: "container-item" },
                                  [
                                    _c("app-validacao-automatizada", {
                                      attrs: {
                                        validacoes: subItem.validacao.validacoes
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            subItem.hasDespachoAutenticavel
                              ? _c("div", { staticClass: "container-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarParecerJuridico(
                                            subItem.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Parecer Jurídico")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.hasExtratoSentenca
                              ? _c("div", { staticClass: "container-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarExtratoSentenca(
                                            subItem.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Extrato de Sentença")]
                                  )
                                ])
                              : _vm._e(),
                            subItem.hasCertidaoArea
                              ? _c("div", { staticClass: "container-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.visualizarCertidaoArea(
                                            subItem.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Certidão de Área")]
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      })
                ],
                2
              )
            }),
            1
          )
        : _c("span", { staticClass: "text-empty" }, [
            _vm._v("Não há informações de despacho deste processo.")
          ]),
      _vm.showModal
        ? _c(
            "app-modal-nova",
            {
              attrs: {
                showModal: _vm.showModal,
                titulo: _vm.tituloMinuta,
                width: 1000,
                padding: 0
              },
              on: {
                closeModal: function($event) {
                  _vm.showModal = false
                }
              }
            },
            [
              _c("template", { slot: "body" }),
              _c(
                "template",
                { slot: "footer" },
                [
                  _c("el-button", { attrs: { size: "small" } }, [
                    _vm._v("Baixar arquivo")
                  ])
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99a3daca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99a3daca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDespachos.vue
// module id = null
// module chunks = 